import * as React from 'react'
import { useIntl } from 'react-intl'

import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import useEndingSoonOfferList from 'hooks/EndingSoonOffer/useEndingSoonOfferList'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import styled from 'styled-components'
import { MIN_OFFER_CAROUSEL_OFFERS_COUNT } from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import useHomepageOfferCarouselList from 'hooks/Offers/useHomepageOfferCarouselList'

const MIN_OFFERS_WITH_COUNTDOWN = MIN_OFFER_CAROUSEL_OFFERS_COUNT
const ENDING_SOON_OFFER_LIMIT = 12

const CarouselContainer = styled(Pane)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

function OfferEndingSoonCarousel() {
  const intl = useIntl()
  const endingSoonOfferList = useEndingSoonOfferList({ limit: ENDING_SOON_OFFER_LIMIT })
  const hasEnoughOffers = endingSoonOfferList.offerIds.length >= MIN_OFFERS_WITH_COUNTDOWN
  const display = useHomepageOfferCarouselList({
    offerList: endingSoonOfferList,
    minimumOffersCount: MIN_OFFERS_WITH_COUNTDOWN,
    applyMinimumOffersCount: true,
    maxDisplayCount: ENDING_SOON_OFFER_LIMIT,
  })

  // TODO: Move visibility decision to SSR to avoid CLS (Cumulative Layout Shift)
  // Currently CSR-only due to stream API limitation. Once unified search API supports
  // ending soon sorting, we can prefetch data server-side and conditionally render.

  if (display.hidden || endingSoonOfferList.fetching || !hasEnoughOffers) {
    return null
  }

  return (
    <CarouselContainer>
      <VerticalSpacer gap={24}>
        <LayoutContainer>
          <Heading variant="heading2">{intl.formatMessage(
            {
              id: 'Yw4KFRYfjiFEmE4VsWwK',
              defaultMessage: 'Offers <i>ending</i> soon',
              description: 'Title for offers ending soon carousel with italicized "ending"',
            },
            {
              i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
            },
          )}
          </Heading>
        </LayoutContainer>
        <OfferListCarousel
          preferListingOffers
          overrideOfferList={display.isActive ? display.offerList : endingSoonOfferList}
          limit={ENDING_SOON_OFFER_LIMIT}
          tabletLimit={ENDING_SOON_OFFER_LIMIT}
          tileStyle="card-default"
          tileSize="medium"
        />
      </VerticalSpacer>
    </CarouselContainer>
  )
}

export default OfferEndingSoonCarousel
